import React, { useState, useEffect, useCallback } from "react"
import { graphql } from "gatsby"
// import emailjs from "emailjs-com"
import { documentToReactComponents } from "@contentful/rich-text-react-renderer"
import Header from "../components/Header"
import Footer from "../components/Footer/Footer"
import Content from "../components/Content"
import AccordionGreen from "../components/AccordionGreen"
import ReactMarkdown from "react-markdown"
import emailjs from "emailjs-com"
import $ from "jquery"
import axios from "axios"
import { CopyToClipboard } from "react-copy-to-clipboard"
import { loadStripe } from "@stripe/stripe-js"
import CheckoutForm from "../components/Stripe/checkoutForm"
import CardCheckout from "../components/Stripe/cardCheckout"
import { Elements } from "@stripe/react-stripe-js"
import Seo from "../components/SEO"
import { Modal } from "react-bootstrap"
import Invoice from "../components/Invoice"

const stripePromise = loadStripe(
  "pk_test_51Rs2ivIdHPhCddPjyIViKxkqvm9WwAlH4L3tzLIB4UmZLSX8kS8htx94VjhZgGTZ03Z47s6aq5oThCGX9PhS9Q7U0099cwAx8t"
)

const TestDrive = ({ data }) => {
  // const [contactName, setContactName] = useState("")
  // const [contactEmail, setContactEmail] = useState("")
  const [fullName, setFullName] = useState("")
  const [companyName, setCompanyName] = useState("")
  const [email, setEmail] = useState("")
  const [mgmtPlanOption, setMgmtPlanOption] = useState("")
  const [projPlanOption, setProjPlanOption] = useState("")
  const [contractTerm, setContractTerm] = useState("Annually")
  const [duration, setDuration] = useState(1)
  const [subEndDate, setSubEndDate] = useState("")
  const [amount, setAmount] = useState(0)
  const [invoiceURL, setInvoiceURL] = useState("")
  const [showPopup, setShowPopup] = useState(false)
  const [showInvoice, setShowInvoice] = useState(false)
  const [copySuccess, setCopySuccess] = useState(false)
  const {
    allContentfulTestDriveNew,
    allContentfulTogglesTestDrivePage,
    allContentfulContentArea,
    allContentfulTestDrivePlans,
    allContentfulCustomQuoteForm,
    allContentfulCustomQuotePrices,
    allContentfulHeader,
    allContentfulSeo,
    allContentfulInvoice,
  } = data

  useEffect(() => {
    // center popup box on screen
    $(".modal-dialog").addClass("modal-dialog-centered")
  })

  useEffect(() => {
    // click on one of the option boxes of the management plan
    $(".mgmt-box").click(function () {
      // change background color and text color
      $(this).children("input").prop("checked", true)
      $(".mgmt-box").removeClass("selected")
      $(this).toggleClass("selected")
      // set value of management plan option
      setMgmtPlanOption($(this).children("input").val())
    })

    // click on one of the option boxes of the project plan
    $(".proj-box").click(function () {
      // change background color and text color
      $(this).children("input").prop("checked", true)
      $(".proj-box").removeClass("selected")
      $(this).toggleClass("selected")
      // set value of project plan option
      setProjPlanOption($(this).children("input").val())
    })

    // click on either box of the contract term options
    $(".billing-box").click(function () {
      // change background color and text color
      $(this).children("input").prop("checked", true)
      $(".billing-box").removeClass("selected")
      $(this).toggleClass("selected")
      // set value of duration text
      if ($(this).children("input").attr("id") === "annually") {
        $("#duration-span").html("YEARS")
      } else if ($(this).children("input").attr("id") === "monthly") {
        $("#duration-span").html("MONTHS")
      }
      // set value of contract term
      setContractTerm($(this).children("input").val())
    })
  })

  const getTotalAmount = useCallback(() => {
    let amount = 0
    // if billed monthly:
    if (contractTerm === "Monthly") {
      if (
        mgmtPlanOption ===
        allContentfulCustomQuoteForm.nodes[0].planOneOptionOne
      ) {
        if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionOne
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly3users1projs // for option of 3 users and 1 project
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionTwo
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly3users3projs // for option of 3 users and 3 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionThree
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly3users10projs // for option of 3 users and 10 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionFour
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly3users25projs // for option of 3 users and 25 projects
        }
      } else if (
        mgmtPlanOption ===
        allContentfulCustomQuoteForm.nodes[0].planOneOptionTwo
      ) {
        if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionOne
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly10users1projs // for option of 10 users and 1 project
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionTwo
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly10users3projs // for option of 10 users and 3 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionThree
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly10users10projs // for option of 10 users and 10 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionFour
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly10users25projs // for option of 10 users and 25 projects
        }
      } else if (
        mgmtPlanOption ===
        allContentfulCustomQuoteForm.nodes[0].planOneOptionThree
      ) {
        if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionOne
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly20users1projs // for option of 20 users and 1 project
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionTwo
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly20users3projs // for option of 20 users and 3 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionThree
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly20users10projs // for option of 20 users and 10 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionFour
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly20users25projs // for option of 20 users and 25 projects
        }
      } else if (
        mgmtPlanOption ===
        allContentfulCustomQuoteForm.nodes[0].planOneOptionFour
      ) {
        if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionOne
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly50users1projs // for option of 50 users and 1 project
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionTwo
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly50users3projs // for option of 50 users and 3 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionThree
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly50users10projs // for option of 50 users and 10 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionFour
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].monthly50users25projs // for option of 50 users and 25 projects
        }
      }
    }
    // if billed annually:
    else if (contractTerm === "Annually") {
      if (
        mgmtPlanOption ===
        allContentfulCustomQuoteForm.nodes[0].planOneOptionOne
      ) {
        if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionOne
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually3users1projs // for option of 3 users and 1 project
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionTwo
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually3users3projs // for option of 3 users and 3 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionThree
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually3users10projs // for option of 3 users and 10 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionFour
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually3users25projs // for option of 3 users and 25 projects
        }
      } else if (
        mgmtPlanOption ===
        allContentfulCustomQuoteForm.nodes[0].planOneOptionTwo
      ) {
        if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionOne
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually10users1projs // for option of 10 users and 1 project
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionTwo
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually10users3projs // for option of 10 users and 3 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionThree
        ) {
          amount =
            allContentfulCustomQuotePrices.nodes[0].annually10users10projs // for option of 10 users and 10 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionFour
        ) {
          amount =
            allContentfulCustomQuotePrices.nodes[0].annually10users25projs // for option of 10 users and 25 projects
        }
      } else if (
        mgmtPlanOption ===
        allContentfulCustomQuoteForm.nodes[0].planOneOptionThree
      ) {
        if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionOne
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually20users1projs // for option of 20 users and 1 project
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionTwo
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually20users3projs // for option of 20 users and 3 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionThree
        ) {
          amount =
            allContentfulCustomQuotePrices.nodes[0].annually20users10projs // for option of 20 users and 10 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionFour
        ) {
          amount =
            allContentfulCustomQuotePrices.nodes[0].annually20users25projs // for option of 20 users and 25 projects
        }
      } else if (
        mgmtPlanOption ===
        allContentfulCustomQuoteForm.nodes[0].planOneOptionFour
      ) {
        if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionOne
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually50users1projs // for option of 50 users and 1 project
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionTwo
        ) {
          amount = allContentfulCustomQuotePrices.nodes[0].annually50users3projs // for option of 50 users and 3 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionThree
        ) {
          amount =
            allContentfulCustomQuotePrices.nodes[0].annually50users10projs // for option of 50 users and 10 projects
        } else if (
          projPlanOption ===
          allContentfulCustomQuoteForm.nodes[0].planTwoOptionFour
        ) {
          amount =
            allContentfulCustomQuotePrices.nodes[0].annually50users25projs // for option of 50 users and 25 projects
        }
      }
    }
    // return total amount
    return amount * duration
  }, [
    mgmtPlanOption,
    projPlanOption,
    contractTerm,
    duration,
    allContentfulCustomQuoteForm.nodes,
    allContentfulCustomQuotePrices.nodes,
  ])

  useEffect(() => {
    // set value of total amount
    setAmount(getTotalAmount())
  }, [getTotalAmount])

  const isLeapYear = year => {
    // check if a year is leap year by checking if February contains 29 days
    return new Date(year, 1, 29).getDate() === 29
  }

  const calculateSubEndDate = useCallback(() => {
    const smallMonths = [4, 6, 9, 11] // months that have 30 days
    // get current year, month, date
    let startFullDate = new Date()
    let startYear = startFullDate.getFullYear()
    let startMonth = startFullDate.getMonth() + 1 // month range 0-11
    let startDate = startFullDate.getDate()
    // calculate sub end year, month, date
    let endYear, endMonth, endDate
    // if duration in years:
    if (contractTerm === "Annually") {
      endYear = startYear + duration
      endMonth = startMonth
      // if current date is Feb 29th, check if end year is leap year to determine end date
      if (startMonth === 2 && startDate === 29) {
        endDate = isLeapYear(endYear) ? 29 : 28
      } else {
        endDate = startDate
      }
    }
    // if duration in months:
    else if (contractTerm === "Monthly") {
      endYear = startYear + Math.floor((startMonth + duration) / 12)
      endMonth = (startMonth + duration) % 12
      // if current date is the 31th and end month only has 30 days, end date is the 30th
      if (startDate === 31 && smallMonths.includes(endMonth)) {
        endDate = 30
      }
      // if current date is 29th, 30th or 31th and end month is Feb,
      // check if end year is leap year to determine end date
      else if (startDate >= 29 && endMonth === 2) {
        endDate = isLeapYear(endYear) ? 29 : 28
      } else {
        endDate = startDate
      }
    }
    // pad end month with "0" if it is single-digit
    endMonth = endMonth.toString()
    endMonth = endMonth.length === 1 ? "0" + endMonth : endMonth
    // pad end date with "0" if it is single-digit
    endDate = endDate.toString()
    endDate = endDate.length === 1 ? "0" + endDate : endDate
    // return sub end date as string
    return endYear + "/" + endMonth + "/" + endDate
  }, [contractTerm, duration])

  useEffect(() => {
    // set value of sub end date after calculation
    setSubEndDate(calculateSubEndDate())
  }, [calculateSubEndDate])

  const resetQuoteForm = () => {
    // reset form data
    $("#customQuoteForm").trigger("reset")
    // reset initial state of contract term options
    $("#duration-span").html("YEARS")
    setContractTerm("Annually")
    // change option boxes back to original style
    $(".mgmt-box,.proj-box,.billing-box").removeClass("selected")
    // hide custom quote popup
    togglePopup()
    // hide copy success message
    setCopySuccess(false)
  }

  const togglePopup = () => {
    setShowPopup(!showPopup)
    return showPopup
  }

  const toggleInvoice = () => {
    setShowInvoice(!showInvoice)
    return showInvoice
  }

  useEffect(() => {
    // display copy success message
    if (copySuccess) {
      window.setTimeout(function () {
        $("#copy-success")
          .fadeTo(500, 0)
          .slideUp(500, function () {
            $("#copy-success").hide()
            setCopySuccess(false)
          })
      }, 2000)
    }
  }, [copySuccess])

  const copyUrl = () => {
    return (
      <CopyToClipboard text={invoiceURL} onCopy={() => setCopySuccess(true)}>
        <button className="btn" type="button">
          {allContentfulCustomQuoteForm.nodes[0].popupButtonOne}
        </button>
      </CopyToClipboard>
    )
  }

  const copySuccessMessage = () => {
    return (
      <div className="alert alert-success" id="copy-success" role="alert">
        {allContentfulCustomQuoteForm.nodes[0].popupCopySuccess}
      </div>
    )
  }

  // const goToInvoice = () => {
  //   return (
  //     <button
  //       className="btn"
  //       type="button"
  //       onClick={() => window.open(invoiceURL)}
  //     >
  //       {allContentfulCustomQuoteForm.nodes[0].popupButtonTwo}
  //     </button>
  //   )
  // }

  // const downloadQuote = () => {
  //   return (
  //     <button className="btn" type="button">
  //       {allContentfulCustomQuoteForm.nodes[0].popupButtonTwo}
  //     </button>
  //   )
  // }

  const openQuote = () => {
    return (
      <button
        className="btn"
        type="button"
        onClick={() => {
          toggleInvoice()
          togglePopup()
        }}
      >
        {allContentfulCustomQuoteForm.nodes[0].popupButtonThree}
      </button>
    )
  }

  const createInvoiceBox = () => {
    return (
      <Invoice
        toggleInvoice={() => toggleInvoice()}
        togglePopup={() => togglePopup()}
        invoiceLogo={allContentfulHeader.nodes[0].logoBlue.file.url}
        titleOfQuote={allContentfulInvoice.nodes[0].titleOfQuote}
        invoiceURL={invoiceURL.substring(invoiceURL.length - 12)}
        serviceDescription={allContentfulInvoice.nodes[0].serviceDescription}
        fullName={fullName}
        email={email}
        companyName={companyName}
        serviceNote={allContentfulInvoice.nodes[0].serviceNote}
        mgmtPlanOption={mgmtPlanOption}
        projPlanOption={projPlanOption}
        contractTerm={contractTerm}
        duration={duration}
        amount={amount}
        subEndDate={subEndDate}
        oneTimeNote={allContentfulInvoice.nodes[0].oneTimeNote}
        oneTimeAmount={allContentfulInvoice.nodes[0].oneTimeAmount}
        vatPercentage={allContentfulInvoice.nodes[0].vat}
      />
    )
  }

  const createPopupBox = () => {
    return (
      <Modal
        show={showPopup}
        onHide={() => resetQuoteForm()}
        className="custom-quote-popup main-text-color"
      >
        <Modal.Header closeButton>
          <Modal.Title>
            {allContentfulCustomQuoteForm.nodes[0].popupHeader}
          </Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <div className="popup-buttons">
            {copyUrl()}
            {openQuote()}
          </div>
          {copySuccess ? copySuccessMessage() : null}
        </Modal.Body>
      </Modal>
    )
  }

  const handleSubmitQuoteForm = e => {
    e.preventDefault()

    emailjs
      .sendForm(
        "service_qkbep48",
        "template_wl24ize",
        e.target,
        "user_H1giHzeT00K7WW4tInQOn"
      )
      .then(
        result => {
          console.log(result)
        },
        error => {
          console.log(error.text)
        }
      )

    const serviceDescription = allContentfulInvoice.nodes[0].serviceDescription
    const serviceNote = allContentfulInvoice.nodes[0].serviceNote
    const oneTimeNote = allContentfulInvoice.nodes[0].oneTimeNote
    const titleOfQuote = allContentfulInvoice.nodes[0].titleOfQuote
    const oneTimeAmount = allContentfulInvoice.nodes[0].oneTimeAmount
    const vat = allContentfulInvoice.nodes[0].vat

    let quoteFormData = new FormData()
    quoteFormData.append("fullname", fullName)
    quoteFormData.append("companyname", companyName)
    quoteFormData.append("email", email)
    quoteFormData.append("mgmt_plan_option", mgmtPlanOption)
    quoteFormData.append("proj_plan_option", projPlanOption)
    quoteFormData.append("title_of_quote", titleOfQuote)
    quoteFormData.append("servicedescription", serviceDescription)
    quoteFormData.append("contractterm", contractTerm)
    quoteFormData.append("duration", duration)
    quoteFormData.append("sub_end_date", subEndDate)
    quoteFormData.append("amount", amount)
    quoteFormData.append("servicenote", serviceNote)
    quoteFormData.append("OneTimeAmount", oneTimeAmount)
    quoteFormData.append("onetimenote", oneTimeNote)
    quoteFormData.append("vat", vat)

    axios({
      method: "post",
      url: "https://quotedandpay.xiir.com/submit-invoice.php",
      data: quoteFormData,
    })
      .then(response => {
        console.log("Submitted")
        console.log(response)
        let url = "https://quotedandpay.xiir.com/" + response.data
        console.log("Invoice URL: " + url)
        setInvoiceURL(url)
        togglePopup()
      })
      .catch(error => {
        console.log(error)
      })
  }

  // const handleSubmitContactForm = e => {
  //   e.preventDefault()
  //   emailjs
  //     .sendForm(
  //       "service_qkbep48",
  //       "template_wl24ize",
  //       e.target,
  //       "user_H1giHzeT00K7WW4tInQOn"
  //     )
  //     .then(
  //       result => {
  //         console.log(result)
  //       },
  //       error => {
  //         console.log(error.text)
  //       }
  //     )
  //   emailjs
  //     .sendForm(
  //       "service_qkbep48",
  //       "template_8hke6d4",
  //       e.target,
  //       "user_H1giHzeT00K7WW4tInQOn"
  //     )
  //     .then(
  //       result => {
  //         console.log(result)
  //       },
  //       error => {
  //         console.log(error.text)
  //       }
  //     )
  //   setContactName("")
  //   setContactEmail("")
  // }

  const showHideStripeOptions = () => {
    var checkbox1 = document.getElementById("paymentOption1")
    // var checkbox2 = document.getElementById("paymentOption2")

    if (checkbox1.checked) {
      document.getElementById("cardOption1").style.display = "none"
      document.getElementById("bankOption1").style.display = "block"
    } else {
      document.getElementById("cardOption1").style.display = "block"
      document.getElementById("bankOption1").style.display = "none"
    }
    // if (checkbox2.checked) {
    //   document.getElementById("cardOption2").style.display = "none"
    //   document.getElementById("bankOption2").style.display = "block"
    // } else {
    //   document.getElementById("cardOption2").style.display = "block"
    //   document.getElementById("bankOption2").style.display = "none"
    // }
  }

  return (
    <div>
      <Seo
        title={allContentfulSeo.nodes[1].title}
        description={allContentfulSeo.nodes[1].description}
        keywords={allContentfulSeo.nodes[1].keywords}
      />
      <Header />
      <section
        className="xiir-benefits contact-section"
        style={{ paddingTop: "120px" }}
      >
        <div className="container">
          <div className="div-head">
            <h3 className="headings-of-all">
              {allContentfulHeader.nodes[0].btnOne}
            </h3>
            <h3 className="ser-head-2">
              {allContentfulTestDriveNew.nodes[0].mainText}
            </h3>
          </div>
          <div className="div-para">
            <h4>
              <ReactMarkdown
                children={
                  allContentfulTestDriveNew.nodes[0].description.description
                }
              />
            </h4>
          </div>
        </div>
      </section>

      <section className="section-padding">
        <div className="container">
          <div className="d-flex justify-content-center">
            <div className="col-sm-12 col-md-6 col-lg-6 text-center">
              <div className="test-drive-plan-div">
                <div className="test-drive-plan-head">
                  <img
                    src={allContentfulTestDrivePlans.nodes[0].icon.file.url}
                    alt="Test Drive Icon"
                  />
                  <h3
                    className="ser-head-2 colorOrange"
                    style={{ textAlign: "center" }}
                  >
                    {allContentfulTestDrivePlans.nodes[0].header}
                    <br />
                    <span id="recommended">
                      &nbsp;&nbsp;
                      {allContentfulTestDrivePlans.nodes[0].recommendText}
                    </span>
                  </h3>
                  <h3 className="ser-head-2">
                    {allContentfulTestDrivePlans.nodes[0].title}
                  </h3>
                </div>
                <div className="test-drive-plan-details">
                  <ReactMarkdown
                    children={
                      allContentfulTestDrivePlans.nodes[0].description
                        .description
                    }
                  />
                </div>
                <div className="test-drive-plan-foot">
                  <h3 className="test-plan-pricing">
                    {allContentfulTestDrivePlans.nodes[0].pricing}
                  </h3>
                  <p>{allContentfulTestDrivePlans.nodes[0].taxText}</p>
                  <label htmlFor="paymentOption1">
                    {allContentfulTestDrivePlans.nodes[0].checkboxText}
                    &nbsp;&nbsp;
                    <span>
                      <input
                        type="checkbox"
                        id="paymentOption1"
                        onClick={showHideStripeOptions}
                      />
                    </span>
                  </label>
                  <center>
                    <div id="cardOption1" style={{ display: "block" }}>
                      <Elements stripe={stripePromise}>
                        <CardCheckout
                          planamount={
                            allContentfulTestDrivePlans.nodes[0].pricing
                          }
                          planname={"One-Time €100 Fee | Start Trial"}
                        />
                      </Elements>
                    </div>
                    <div id="bankOption1" style={{ display: "none" }}>
                      <Elements stripe={stripePromise}>
                        <CheckoutForm
                          planamount={
                            allContentfulTestDrivePlans.nodes[0].pricing
                          }
                          planname={"One-Time €100 Fee | Start Trial"}
                        />
                      </Elements>
                    </div>
                  </center>
                </div>
              </div>
            </div>
            {/* <div className="col-sm-12 col-md-6 col-lg-6 text-center">
              <div className="test-drive-plan-div">
                <div className="test-drive-plan-head">
                  <img
                    src={allContentfulTestDrivePlans.nodes[1].icon.file.url}
                    alt="Self Drive Icon"
                  />
                  <h3 className="ser-head-2 colorOrange">
                    {allContentfulTestDrivePlans.nodes[1].header}
                  </h3>
                  <h3 className="ser-head-2">
                    {allContentfulTestDrivePlans.nodes[1].title}
                  </h3>
                </div>
                <div className="test-drive-plan-details">
                  <ReactMarkdown
                    children={
                      allContentfulTestDrivePlans.nodes[1].description
                        .description
                    }
                  />
                </div>
                <div className="test-drive-plan-foot">
                  <h3 className="test-plan-pricing">
                    {allContentfulTestDrivePlans.nodes[1].pricing}
                  </h3>
                  <p>{allContentfulTestDrivePlans.nodes[1].taxText}</p>
                  <label htmlFor="paymentOption2">
                    {allContentfulTestDrivePlans.nodes[1].checkboxText}
                    &nbsp;&nbsp;
                    <span>
                      <input
                        type="checkbox"
                        id="paymentOption2"
                        onClick={showHideStripeOptions}
                      />
                    </span>
                  </label>
                  <center>
                    <div id="cardOption2" style={{ display: "block" }}>
                      <Elements stripe={stripePromise}>
                        <CardCheckout
                          planamount={
                            allContentfulTestDrivePlans.nodes[1].pricing
                          }
                          planname={"Self Drive"}
                        />
                      </Elements>
                    </div>
                    <div id="bankOption2" style={{ display: "none" }}>
                      <Elements stripe={stripePromise}>
                        <CheckoutForm
                          planamount={
                            allContentfulTestDrivePlans.nodes[1].pricing
                          }
                          planname={"Self Drive"}
                        />
                      </Elements>
                    </div>
                  </center>
                </div>
              </div>
            </div> */}
          </div>
        </div>
      </section>

      <div className="section-padding-2">
        <Content
          main1={allContentfulContentArea.nodes[3].textMain1.textMain1}
          main2={allContentfulContentArea.nodes[3].textMain2.textMain2}
          side1={allContentfulContentArea.nodes[3].textSide1.textSide1}
          side2={allContentfulContentArea.nodes[3].textSide2.textSide2}
          className="gr-bg"
        />
      </div>
      <section className="section-padding d-flex">
        <div className="container">
          <div>
            <div className="row">
              <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                <div id="request-custom-quote">
                  {allContentfulTogglesTestDrivePage.nodes.map((v, i) => (
                    <AccordionGreen
                      title={v.title}
                      content={documentToReactComponents(
                        JSON.parse(v.description.raw)
                      )}
                      key={i}
                    />
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/*<section className="download-box section-padding">
        <div className="container">
          <div className="our-media">
            <h3 className="ser-head-2">
              {allContentfulTestDriveNew.nodes[0].inputTitle}
            </h3>
          </div>
          <div className="box">
            <div className="datasheet-down">
              <form onSubmit={handleSubmitContactForm}>
                <div className="input">
                  <input
                    placeholder="full name"
                    value={contactName}
                    type="text"
                    name="contact_name"
                    style={{ marginBottom: "10px" }}
                    onChange={e => setContactName(e.currentTarget.value)}
                  />
                  <input
                    placeholder="email"
                    value={contactEmail}
                    type="email"
                    name="contact_email"
                    style={{ marginBottom: "10px" }}
                    onChange={e => setContactEmail(e.currentTarget.value)}
                  />
                </div>
                <br />
                <div>
                  <button type="submit" className="btn btn-purple">
                    submit
                  </button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>*/}
      <Footer />
    </div>
  )
}

export default TestDrive

export const query = graphql`
  query {
    allContentfulTestDriveNew {
      nodes {
        title
        description {
          description
        }
        subTitle
        subDescription
        inputTitle
        mainText
        planTwo {
          file {
            url
          }
        }
        planOne {
          file {
            url
          }
        }
        commingSoonImg {
          file {
            url
          }
        }
      }
    }
    allContentfulContentArea(sort: { fields: createdAt }) {
      nodes {
        textMain1 {
          textMain1
        }
        textMain2 {
          textMain2
        }
        textSide1 {
          textSide1
        }
        textSide2 {
          textSide2
        }
      }
    }
    allContentfulTogglesTestDrivePage(
      sort: { fields: createdAt, order: DESC }
    ) {
      nodes {
        title
        description {
          raw
        }
      }
    }
    allContentfulTestDrivePlans(sort: { fields: createdAt }) {
      nodes {
        icon {
          file {
            url
          }
        }
        header
        title
        description {
          description
        }
        pricing
        checkboxText
        recommendText
        taxText
      }
    }
    allContentfulInvoice {
      nodes {
        serviceDescription
        serviceNote
        oneTimeNote
        titleOfQuote
        oneTimeAmount
        vat
      }
    }
    allContentfulCustomQuoteForm {
      nodes {
        title
        inputFieldOne
        inputFieldTwo
        inputFieldThree
        inputFieldFour
        choosePlanHeaderOne
        choosePlanHeaderTwo
        choosePlanHeaderThree
        choosePlanIconOne {
          file {
            url
          }
        }
        choosePlanIconTwo {
          file {
            url
          }
        }
        choosePlanIconThree {
          file {
            url
          }
        }
        textSelectOption
        planOneOptionOne
        planOneOptionTwo
        planOneOptionThree
        planOneOptionFour
        planTwoOptionOne
        planTwoOptionTwo
        planTwoOptionThree
        planTwoOptionFour
        billingOptionOne
        billingOptionTwo
        button
        popupHeader
        popupButtonOne
        popupButtonTwo
        popupButtonThree
        popupCopySuccess
      }
    }
    allContentfulCustomQuotePrices {
      nodes {
        monthly3users1projs
        monthly3users3projs
        monthly3users10projs
        monthly3users25projs
        monthly10users1projs
        monthly10users3projs
        monthly10users10projs
        monthly10users25projs
        monthly20users1projs
        monthly20users3projs
        monthly20users10projs
        monthly20users25projs
        monthly50users1projs
        monthly50users3projs
        monthly50users10projs
        monthly50users25projs
        annually3users1projs
        annually3users3projs
        annually3users10projs
        annually3users25projs
        annually10users1projs
        annually10users3projs
        annually10users10projs
        annually10users25projs
        annually20users1projs
        annually20users3projs
        annually20users10projs
        annually20users25projs
        annually50users1projs
        annually50users3projs
        annually50users10projs
        annually50users25projs
      }
    }
    allContentfulHeader {
      nodes {
        btnOne
        logoBlue {
          file {
            url
          }
        }
      }
    }
    allContentfulSeo(sort: { fields: createdAt }) {
      nodes {
        title
        description
        keywords
      }
    }
  }
`
